import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useAuth from "@/services/hooks/auth/useAuth";
import { LoadingContainer, LoadingText, Spinner } from "./styles";

export default function Verify() {
  const navigate = useNavigate();
  const { verify, statusVerify, isPendingRefreshToken } = useAuth();

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  useEffect(() => {
    if (token && statusVerify === "idle") {
      verify({ token: token });
    }
  }, [token, statusVerify, verify]);

  useEffect(() => {
    if (!isPendingRefreshToken && statusVerify === "success") {
      navigate("/");
    } else if (!isPendingRefreshToken && statusVerify === "error") {
      navigate("/access-denied");
    }
  }, [isPendingRefreshToken, statusVerify, navigate]);

  return (
    <LoadingContainer>
      <Spinner
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="spinner-secondHalf">
            <stop offset="0%" stopOpacity="0.5" stopColor="currentColor" />
            <stop offset="100%" stopOpacity="0" stopColor="currentColor" />
          </linearGradient>
          <linearGradient id="spinner-firstHalf">
            <stop offset="0%" stopOpacity="0.5" stopColor="currentColor" />
            <stop offset="100%" stopOpacity="1" stopColor="currentColor" />
          </linearGradient>
        </defs>

        <g strokeWidth="20">
          <path
            stroke="url(#spinner-secondHalf)"
            d="M 10 100 A 90 90 0 0 1 190 100"
          />
          <path
            stroke="url(#spinner-firstHalf)"
            d="M 190 100 A 90 90 0 0 1 10 100"
          />
        </g>

        <animateTransform
          from="360 0 0"
          to="0 0 0"
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1300ms"
        />
      </Spinner>
      <LoadingText>
        {isPendingRefreshToken ? "Verifying your credentials..." : "Please wait..."}
      </LoadingText>
    </LoadingContainer>
  );
}
